export type Order = 'asc' | 'desc';
export const DEFAULT_SORT_CONTACT_TABLE = 'fechaInicio';